import { FC, ReactNode, useEffect, useRef, useState } from 'react'
import dynamic from 'next/dynamic'
import clsx from 'clsx'

const PortalWrap = dynamic(() => import('containers/portal-wrap/portal-wrap'), { ssr: false })
import useOnClickOutside from 'hooks/useClickOutside'

import { createMessageStyle } from './data'
import { Events } from 'constants/events'

import styles from './hint-message.module.scss'

interface IHintMessage {
  message: string
  children: ReactNode
  wrapperModificator?: string
}

const HintMessage: FC<IHintMessage> = ({ children, message, wrapperModificator }) => {
  const [isShow, setShow] = useState(false)
  const [position, setPosition] = useState({})
  const messageRef = useRef(null)
  const childrenRef = useRef(null)

  const clickHandler = () => {
    if (childrenRef.current) {
      const styleMessage = createMessageStyle(childrenRef.current)
      setPosition(styleMessage)
    }

    setShow((prevState) => !prevState)
  }

  useOnClickOutside(isShow, childrenRef, clickHandler)

  useEffect(() => {
    const hideMessageOnScroll = () => {
      !isShow && setShow(false)
    }
    document.addEventListener(Events.WHEEL, hideMessageOnScroll)
    document.addEventListener(Events.TOUCHSTART, hideMessageOnScroll)
    return () => {
      document.removeEventListener(Events.WHEEL, hideMessageOnScroll)
      document.removeEventListener(Events.TOUCHSTART, hideMessageOnScroll)
    }
  }, [])

  return (
    <span className={clsx(styles.wrapper, { [wrapperModificator as string]: wrapperModificator })}>
      <span className={styles.childrenWrapper} onClick={(clickHandler)} ref={childrenRef}>
        {children}
      </span>
      {isShow && (
        <PortalWrap>
          <span className={styles.message}  style={position} ref={messageRef}>
            <span>{message}</span> <span className={styles.close} onClick={clickHandler}></span>
          </span>
        </PortalWrap>
      )}
    </span>
  )
}

export default HintMessage
